import TimeInput from './timeInput'
import TimeInputRange from './timeInputRange'

TimeInput.TimeInputRange = TimeInputRange

export default TimeInput